import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getCurrentDate } from '../../../../helpers/Common';
import { TIME_FILTERS } from '../../Const';
import {
  REDUCER_NAME,
  downloadBalanceSheet,
  downloadCashFlow,
  downloadIncomeStatement,
} from '../../reducer';
import ExportBlob from '../../../../common/export-blob';

class ExportCommon extends React.Component {
  handleExport = () => {
    const { currentTab } = this.props;
    this.handleDownLoadByTab(currentTab);
  };

  handleDownLoadByTab = currentTab => {
    const mapTimeFilter = {
      [TIME_FILTERS.QUARTERLY]: 'Quarterly',
      [TIME_FILTERS.YEARLY]: 'Yearly',
    };
    const {
      downloadBalanceSheet,
      downloadCashFlow,
      downloadIncomeStatement,
      organCode,
      skip,
      timeFilter,
      displayCode,
    } = this.props;
    const apiParams = {
      OrganCode: organCode,
      Skip: skip,
      Frequency: mapTimeFilter[timeFilter],
    };
    const i18nParams = {
      ticker: displayCode,
      date: getCurrentDate(),
    };
    switch (currentTab) {
      case 2:
        const incomeStatementExportName = I18n.t(
          'common.export.financialStatement.incomeStatement',
          i18nParams,
        );
        return downloadIncomeStatement(
          { ...apiParams },
          incomeStatementExportName,
        );
      case 3:
        const cashFlowStateExportName = I18n.t(
          'common.export.financialStatement.cashFlowStatement',
          i18nParams,
        );
        return downloadCashFlow({ ...apiParams }, cashFlowStateExportName);
      default:
        const balanceSheetExportName = I18n.t(
          'common.export.financialStatement.balanceSheet',
          i18nParams,
        );
        return downloadBalanceSheet({ ...apiParams }, balanceSheetExportName);
    }
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = (state, props) => {
  const { componentId } = props;
  return {
    skip: state[REDUCER_NAME][componentId].skip,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = {
  downloadBalanceSheet,
  downloadCashFlow,
  downloadIncomeStatement,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportCommon);
